export default {
  carta: "LETTERA",
  yourLastOrders: "I TUOI ULTIMI ORDINI",
  productOrderNotAvailable:
    "Siamo spiacenti, il prodotto che stai ordinando non è disponibile.s",
  noOrders: "Non hai ancora ordini",
  updated: "Aggiornato!",
  updatingzClosuresSummaryCollection:
    "Aggiornamento della raccolta di riepilogo di zClosures in corso...",
  updateOrdersAndPaymentSummariesCollection:
    "Aggiornamento ordini e incasso riepiloghi pagamenti...",
  whatDishesAre: "Che piatti sono",
  theMaximumNumberOfProductAllowed:
    "Il numero massimo di prodotti consentiti è 20",
  orderPlaced: "Ordine effettuato",
  updatePaymentsCollection: "Aggiornamento della riscossione dei pagamenti ..."
};
